import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { GebaeudeEingangAdresseVersionDetailEntryMeta } from '../../../core/av-api';
import { EingangAdresseMasterVM } from '../../../vermessung/gebaeude/gebaeude-detail/gebaeude-eingangsadressen/gebaeude-eingangsadressen.component';

@Pipe({
  name: 'orderByEingangadresse'
})
export class OrderByEingangadressePipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array: Array<EingangAdresseMasterVM>, ascending = true): Array<EingangAdresseMasterVM> {
    if (ascending) {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item1.version, item2.version);
      });
    } else {
      return Array.from(array).sort((item1: any, item2: any) => {
        return this.orderByComparator(item2.version, item1.version);
      });
    }
  }

  private orderByComparator(a: GebaeudeEingangAdresseVersionDetailEntryMeta, b: GebaeudeEingangAdresseVersionDetailEntryMeta): number {
    return this.comperatorService.eingangadressenComparator(a, b);
  }
}
